/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/10/18
 * Time: 上午10:22
 */

/* 规定数据结构如下：
插入：
pos: [
  {
    retain: 1 // 保留前面的字符数量
  },
  {
    insert: "字符串", // 插入的内容
    attributes: {
      bold: true,
      ...
    },
  }
  ...
]
删除：
ops: [
  {
    retain: 1 // 保留前面的字符数量
  },
  {
    delete: 2 // 删除的长度
  }
]
修改：
ops: [
  {
    retain: 1 // 保留前面的字符数量
  },
  {
    attributes: {
      bold: true,
      ...
    },
    retain: 2  // 当前样式作用的字符长度
  }
  ...
] */

import _ from 'lodash'

export function getOpsType (ops) {
  if (!ops || !Array(ops) || ops.length === 0) {
    throw new Error('ops expects an array')
  }

  const retainOps = _.find(ops, (item) => item.retain)
  const insertOps = _.find(ops, (item) => item.insert)
  const deleteOps = _.find(ops, (item) => item.delete)

  if (insertOps && !deleteOps) return 0
  if (deleteOps && !insertOps) return 1
  if (retainOps && !deleteOps && !insertOps) return 2
  return -1
}

export function isRetain (ops) {
  return getOpsType(ops) === 2
}

export function isDelete (ops) {
  return getOpsType(ops) === 1
}

export function isInsert (ops) {
  return getOpsType(ops) === 0
}

/**
 * 在字符串指定位置插入新的字符
 * @param sourceStr
 * @param index
 * @param newStr
 * @return {*}
 * @private
 */
function _insertStr (sourceStr, index, newStr) {
  return sourceStr.slice(0, index) + newStr + sourceStr.slice(index)
}

/**
 * 从指定位置向后删除指定长度
 * @param sourceStr
 * @param index
 * @param length
 * @return {*}
 * @private
 */
export function deleteStr (sourceStr, index, length) {
  return sourceStr.slice(0, index) + sourceStr.slice(index + length)
}

/**
 * 获取操作保留长度的那个对象
 * @param ops
 * @private
 */
export function getOpsRetainObj (ops) {
  if (!ops || !Array(ops) || ops.length === 0) {
    throw new Error('ops expects an array')
  }

  return _.find(ops, (item) => {
    return item.retain && !item.insert && !item.attributes && !item.delete
  })
}

/**
 * 获取保留的长度
 * @param ops
 * @return {number|*}
 * @private
 */
export function getOpsRetainLength (ops) {
  const opsRetainObj = getOpsRetainObj(ops)
  if (opsRetainObj && opsRetainObj.retain) return opsRetainObj.retain
}

/**
 * 获取操作的那个对象
 * @param ops
 * @private
 */
export function getOpsObj (ops) {
  if (!ops || !Array(ops) || ops.length === 0) {
    throw new Error('ops expects an array')
  }

  return _.find(ops, (item) => {
    return item.insert || item.attributes || item.delete
  })
}

/**
 * 获取想要作用于的文本的长度
 * @param ops
 * @return {*}
 * @private
 */
function _getOpsLength (ops) {
  if (!ops || !Array(ops) || ops.length === 0) {
    throw new Error('ops expects an array')
  }
  let length = 0

  if (isInsert(ops)) {
    const insertArr = _.filter(ops, item => item.insert)
    insertArr.map((item) => {
      length = length + item.insert.length
    })

    return length
  }

  if (isRetain(ops)) {
    let retainLength = []
    const retainArr = _.filter(ops, (item) => {
      return item.retain && item.attributes
    })

    retainArr.map((item) => {
      retainLength.push(item.retain)
    })

    return retainLength
  }

  if (isDelete(ops)) {
    const deleteArr = _.filter(ops, item => item.delete)
    deleteArr.map((item) => {
      length = length + item.delete
    })

    return length
  }
}

/**
 * 更改operationNextCollection基于的版本，本来operationNextCollection
 * 的操作集合是基于operationLast的，次方法可将operationNextCollection
 * 修改为operationLast基于的版本，使operationLast和operationNextCollection
 * 基于的是同一个版本（版本回退操作）
 * @param operationNextCollection
 * @param operationLast
 */
export function changeOpsVersion (operationNextCollection, operationLast) {
  if (typeof operationNextCollection === 'undefined' || !_.isArray(operationNextCollection) || operationNextCollection.length === 0) {
    throw new Error('params1 expects an array collection.')
  }

  if (typeof operationNext === 'undefined' || !_.isArray(operationLast) || operationLast.length === 0) {
    throw new Error('params2 expects an array.')
  }

  const lastOpsRetainLength = getOpsRetainLength(operationLast) // 这个操作所保留的长度
  const lastOpsLength = _getOpsLength(operationLast) // 这个操作所作用的长度
}

/**
 * 根据一个操作来更正与之版本相同的一连串操作
 * @param baseOpsCollection 基本数据集
 * @param operationNext 即将影响数据集的操作
 * @param debug 是否开始调试
 */
export function transform (baseOpsCollection, operationNext, debug) {
  if (typeof baseOpsCollection === 'undefined' || !_.isArray(baseOpsCollection) || baseOpsCollection.length === 0) {
    return baseOpsCollection
    // throw new Error('params1 expects an array or array collection.')
  }

  if (typeof operationNext === 'undefined' || !_.isArray(operationNext) || operationNext.length === 0) {
    return baseOpsCollection
    // throw new Error('params1 expects an array.')
  }

  const nextOpsRetainLength = getOpsRetainLength(operationNext) // 这个操作所保留的长度
  const nextOpsLength = _getOpsLength(operationNext) // 这个操作所作用的长度
  const nextOpsCtrLength = nextOpsRetainLength + nextOpsLength // 这个操作所影响的长度
  let operationLast = _.isArray(baseOpsCollection[0]) ? baseOpsCollection : [baseOpsCollection]

  // 开始进行更正操作
  operationLast.map((opsItem, index) => {
    const curOpsRetainLength = getOpsRetainLength(opsItem) // 这个操作所保留的长度
    const curOpsLength = _getOpsLength(opsItem) // 这个操作所作用的长度
    const curOpsCtrLength = curOpsRetainLength + curOpsLength // 这个操作所影响的长度
    let curOpsRetainObj = getOpsRetainObj(opsItem)
    let curOpsObj = getOpsObj(opsItem)

    if (curOpsCtrLength <= nextOpsRetainLength) return

    if (isInsert(operationNext) && isRetain(opsItem)) {
      // nextOPs/curOps = insert/retain
      if (debug) console.log('nextOPs/curOps = insert/retain')
      if (curOpsRetainLength < nextOpsRetainLength && nextOpsRetainLength < curOpsCtrLength) {
        curOpsObj.retain += nextOpsLength
      } else if (curOpsRetainLength >= nextOpsRetainLength) {
        curOpsRetainObj.retain += nextOpsLength
      }
    } else if (isInsert(operationNext) && isDelete(opsItem)) {
      // nextOPs/curOps = insert/delete
      if (debug) console.log('nextOPs/curOps = insert/delete')
      if (curOpsRetainLength < nextOpsRetainLength && nextOpsRetainLength < curOpsCtrLength) {
        curOpsObj.delete = nextOpsRetainLength - curOpsRetainLength
        let extraOps = [
          {retain: curOpsRetainLength + nextOpsLength},
          {delete: curOpsLength - (nextOpsRetainLength - curOpsRetainLength)}
        ]
        operationLast.splice(index + 1, 0, extraOps)
      } else if (curOpsRetainLength >= nextOpsRetainLength) {
        curOpsRetainObj.retain += nextOpsLength
      }
    } else if (isInsert(operationNext) && isInsert(opsItem)) {
      // nextOPs/curOps = insert/insert
      if (debug) console.log('nextOPs/curOps = insert/insert')
      if (curOpsRetainLength > nextOpsRetainLength) {
        curOpsRetainObj.retain += nextOpsLength
      }
    } else if (isDelete(operationNext) && isRetain(opsItem)) {
      // nextOPs/curOps = delete/retain
      if (debug) console.log('nextOPs/curOps = delete/retain')
      if (curOpsCtrLength <= nextOpsCtrLength) {
        if (curOpsRetainLength < nextOpsRetainLength) {
          curOpsObj.retain = curOpsLength - (curOpsCtrLength - nextOpsRetainLength)
        } else {
          operationLast.splice(index, 1)
        }
      } else {
        if (curOpsRetainLength > nextOpsRetainLength) {
          curOpsRetainObj.retain = nextOpsRetainLength
          curOpsObj.retain = curOpsCtrLength - nextOpsCtrLength
        }
      }

      if (curOpsRetainLength >= nextOpsCtrLength) {
        curOpsRetainObj.retain -= nextOpsLength
      }
    } else if (isDelete(operationNext) && isInsert(opsItem)) {
      // nextOPs/curOps = delete/insert
      if (debug) console.log('nextOPs/curOps = delete/insert')
      if (curOpsRetainLength > nextOpsRetainLength && curOpsRetainLength < nextOpsCtrLength) {
        curOpsRetainObj.retain = nextOpsRetainLength
      }

      if (curOpsRetainLength >= nextOpsCtrLength) {
        curOpsRetainObj.retain = curOpsRetainLength - nextOpsLength
      }
    } else if (isDelete(operationNext) && isDelete(opsItem)) {
      // nextOPs/curOps = delete/delete
      if (debug) console.log('nextOPs/curOps = delete/delete')
      if (curOpsCtrLength <= nextOpsCtrLength) {
        if (curOpsRetainLength < nextOpsRetainLength) {
          curOpsObj.delete = curOpsLength - (curOpsCtrLength - nextOpsRetainLength)
        } else {
          operationLast.splice(index, 1)
        }
      } else {
        if (curOpsRetainLength > nextOpsRetainLength) {
          curOpsRetainObj.retain = nextOpsRetainLength
          curOpsObj.delete = curOpsCtrLength - nextOpsCtrLength
        }
      }

      if (curOpsRetainLength >= nextOpsCtrLength) {
        curOpsRetainObj.retain -= nextOpsLength
      }
    }
  })

  return operationLast
}

/**
 * 合并一连串的操作
 * @param baseOpsCollection 基础操作集合
 */
export function compose (baseOpsCollection) {
  if (typeof baseOpsCollection === 'undefined' || !_.isArray(baseOpsCollection) || baseOpsCollection.length === 0) {
    throw new Error('ops1 expects an array.')
  }

  let opsCollection = _.cloneDeep(baseOpsCollection)
  let opsResult = []

  opsCollection.map((opsItem, index) => {
    if (opsResult.length === 0) {
      opsResult.push(opsItem)
      return
    }

    if (opsResult.length > 1) {
      opsResult.push(opsItem)
      return
    }

    const firstRetainLength = getOpsRetainLength(opsResult[0])
    const nextRetainLength = getOpsRetainLength(opsItem)
    const firstOpsLength = _getOpsLength(opsResult[0])
    const nextOpsLength = _getOpsLength(opsItem)
    const firstOpsCtrLength = firstRetainLength + firstOpsLength // 这个操作所影响的长度
    const nextOpsCtrLength = nextRetainLength + nextOpsLength // 这个操作所影响的长度
    let firstOpsObj = getOpsObj(opsResult[0])
    let firstRetainObj = getOpsRetainObj(opsResult[0])
    let nextOpsObj = getOpsObj(opsItem)

    if (getOpsType(opsResult[0]) !== getOpsType(opsItem)) {
      if (nextRetainLength >= firstOpsCtrLength && isDelete(opsItem)) return
      let condition = isInsert(opsResult[0]) && isDelete(opsItem) && firstOpsCtrLength >= nextOpsCtrLength && firstRetainLength <= nextRetainLength

      if (condition) {
        firstOpsObj.insert = deleteStr(firstOpsObj.insert, nextRetainLength - firstRetainLength, nextOpsLength)
      } else {
        opsResult.push(opsItem)
      }
    } else {
      // 仅仅处理下面两种情况，本来代码可以写的更简洁点，但是不太容易阅读，这里就不合在一起了
      if (isInsert(opsResult[0]) && isInsert(opsItem)) {
        if (firstOpsCtrLength >= nextRetainLength && nextRetainLength >= firstRetainLength) {
          firstOpsObj.insert = _insertStr(firstOpsObj.insert, nextRetainLength - firstRetainLength, nextOpsObj.insert)
        } else {
          opsResult.push(opsItem)
        }
      }

      if (isDelete(opsResult[0]) && isDelete(opsItem)) {
        if (firstRetainLength - firstOpsLength === nextRetainLength) {
          firstOpsObj.delete = firstOpsLength + nextOpsLength
          if (index === opsCollection.length - 1) firstRetainObj.retain = nextRetainLength
        } else {
          opsResult.push(opsItem)
        }
      }
    }
  })

  return opsResult
}

/**
 * 回退operationCollection集合里面的每一项操作到没有baseOperation操作的状态
 * @param operationCollection
 * @param baseOperation
 */
export function rollback (operationCollection, baseOperation) {
  if (typeof operationCollection === 'undefined' || !_.isArray(operationCollection) || operationCollection.length === 0) {
    return operationCollection
    // throw new Error('params1 expects an array or array collection.')
  }

  if (typeof baseOperation === 'undefined' || !_.isArray(baseOperation) || baseOperation.length === 0) {
    return operationCollection
    // throw new Error('params1 expects an array.')
  }

  operationCollection.map(itemOps => {
    const baseOpsRetainLength = getOpsRetainLength(baseOperation)
    const baseOpsLength = _getOpsLength(baseOperation)

    if (isInsert(itemOps) && isInsert(baseOperation)) {
      const itemOpsRetainLength = getOpsRetainLength(itemOps)
      let itemOpsRetainObj = getOpsRetainObj(itemOps)

      if (baseOpsRetainLength < itemOpsRetainLength) {
        itemOpsRetainObj.retain += baseOpsLength
      }
    }
  })

  return operationCollection
}

/**
 * 由于业务原因，需要某些情况下retain长度一样也要作为冲突解决
 * @param baseOpsCollection 受影响的集合
 * @param operationNext 将影响的数据
 * @param debug 是否开启调试
 */
export function transformRetainEqual (baseOpsCollection, operationNext, debug) {
  let curOps = _.cloneDeep(operationNext)
  let curOpsRetainObj = getOpsRetainObj(curOps)
  if (getOpsRetainLength(baseOpsCollection[0]) === getOpsRetainLength(operationNext)) curOpsRetainObj.retain--
  return transform(baseOpsCollection, curOps)
}



//////////////////
// WEBPACK FOOTER
// ./lib/ot.js
// module id = null
// module chunks = 